const Feature = ({ icon = "", title = "", description = "" }) => {
  return (
    <div className="features-box mt-5 text-end">
      <div className="features-icon float-end ms-2">
        <i className={`uil ${icon}`}></i>
      </div>
      <div className="pe-3 me-5">
        <h5 className="f-15 text-uppercase">{title}</h5>
        <p className="text-muted mt-3">{description}</p>
      </div>
    </div>
  );
};

export default Feature;
